import { TextSeparator } from '@/components/custom';
import { IHasChildren } from '@/lib/interface';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type TProps = IHasChildren & {
	title: ReactNode;
}

const ContentPageGroup = ({ children, title }: TProps) => (
	<div className='flex flex-col space-y-3 md:space-y-5'>
		<div className='lg:mx-20'>
			<TextSeparator title={title} />
		</div>
		<div className={cn(
			'grid grid-cols-2 gap-2 mt-3', // default
			'sm:grid-cols-3 sm:gap-6 sm:mt-8', // sm
			'md:grid-cols-4 md:gap-8', // md
			'lg:grid-cols-6', // lg
			'lg:mx-20' // lg
		)}>
			{children}
		</div>
	</div>
);

export default ContentPageGroup;
